var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":_vm.size,"variant":_vm.variant},on:{"click":function($event){return _vm.startFlow(_vm.id)}}},[_c('i',{staticClass:"fas fa-list-check"}),_vm._v(" Walk Me Through This")])}
var staticRenderFns = []

export { render, staticRenderFns }